import type { ComponentType } from "svelte";

import { goto as _goto } from "$app/navigation";
import { BehaviorSubject } from "rxjs";
import { query } from "$lib/util/url";

let go = _goto;

let closingAll = false;
const gotos: string[] = [];

export function goto(url: string) {
	if (closingAll) {
		gotos.push(url);
	} else {
		_goto(url, { noScroll: true });
	}
}

const closers = new Set<() => void>();

export function registerModal(close: () => void) {
	closers.add(close);
}

export function deregisterModal(close: () => void) {
	closers.delete(close);
}

export function closeAllModals(currentUrl: URL) {
	closingAll = true;
	for (const close of closers) {
		close();
	}
	closingAll = false;
	// closers.clear(); // each `close()` should result in a `deregisterModal` call

	const from = query(currentUrl);
	const paramsToRemove = new Set<string>();
	gotos.forEach(targetUrl => {
		// params that are in the current URL but not in the target URL is what we want to remove
		const { onlyInThis } = from.diffParams(targetUrl);
		onlyInThis.forEach(key => paramsToRemove.add(key));
	});
	gotos.length = 0; // reset for next closeAllModals attempt
	if (paramsToRemove.size === 0) return;
	from.remove(...paramsToRemove).go();
}

export function mockGoto(mock: typeof _goto) {
	go = mock;
}

// opening modal programmatically
const _modal$ = new BehaviorSubject<ComponentType | null>(null);

export const modal$ = _modal$.asObservable();

export function openModal(component: ComponentType) {
	_modal$.next(component);
}
